export const LEVELROLE = 'LEVELROLE';
export const RESOURCES = 'RESOURCES';
export const LEVEL_ROLE_QUESTIONS = 'LEVEL_ROLE_QUESTIONS';
export const ASSESSMENT_HISTORY = 'ASSESSMENT_HISTORY';
export const ASSESSMENT_HISTORY_MASTER = "ASSESSMENT_HISTORY_MASTER";